import { render, staticRenderFns } from "./SeminarEntryBulkMessage.vue?vue&type=template&id=e79a8846"
import script from "./SeminarEntryBulkMessage.vue?vue&type=script&lang=js"
export * from "./SeminarEntryBulkMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports